import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col } from 'reactstrap';
import './GettingStarted.scss';

class GettingStarted extends React.Component { // eslint-disable-line react/prefer-stateless-function
  static propTypes = {};

  static defaultProps = {};

  componentDidMount() {
    window.scrollTo({ top: 0 });
  }

  render() {
    return (
      <div className="getting-started-page" style={{ 'font-size': 'large' }}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Getting Started</title>
        </Helmet>

        <Container className="content-container mt-5 mb-5">
          <Row>
            <Col>
              <h1 className="page-title mb-4">HOW TO GET STARTED DOING BUSINESS WITH DOD</h1>
              
              <div className="intro-box mb-4">
                <p className="lead">
                  Doing business with the DOD will require certain registrations and certifications:
                </p>
              </div>

              {/* Step 1: SAM.gov Registration */}
              <div className="step-card">
                <div className="step-header">
                  <div className="step-number">1</div>
                  <div className="step-title">
                    <h3>Register with SAM.gov</h3>
                  </div>
                </div>
                <div className="step-content">
                  <p>
                    Register your organization in <a href="http://sam.gov/" target="_blank" rel="noopener noreferrer">SAM.gov</a> - You don&apos;t need a CAGE code to engage with ICON but in order to secure a government defense contract industry must register in SAM.gov and have a valid CAGE code. If you don&apos;t have a current CAGE you can obtain one.
                  </p>
                  <ul>
                    <li>The CAGE code is assigned as part of this process for U.S.-based entities, and it is free.</li>
                    <li>For non-U.S. entities, an NCAGE code must be obtained first from NATO Support and Procurement Agency (NSPA) or a country&apos;s National Codification Bureau.</li>
                    <li>If you do not have a CAGE code ICON will create a user ID code for you.</li>
                    <li>If you do receive a CAGE code at a later date, your profile can be updated to reflect your new CAGE code.</li>
                  </ul>
                </div>
              </div>

              {/* Step 2: DIBBS Registration */}
              <div className="step-card">
                <div className="step-header">
                  <div className="step-number">2</div>
                  <div className="step-title">
                    <h3>Register with DIBBS</h3>
                  </div>
                </div>
                <div className="step-content">
                  <p>
                    Register with the <a href="https://www.dibbs.bsm.dla.mil/" target="_blank" rel="noopener noreferrer">DLA Internet Bid Board System (Department of Defense (DOD) Warning and Consent ~ DIBBS)</a> - DIBBS registration provides ICON users with access to:
                  </p>
                  <ul>
                    <li>Technical Data Packages (TDP drawings and prints) otherwise known as cFolders</li>
                    <li>Also, other valuable information, for example how to submit Post Award Requests (PARS) and Batch quoting.</li>
                  </ul>
                </div>
              </div>

              {/* Step 3: JCP Certification */}
              <div className="step-card">
                <div className="step-header">
                  <div className="step-number">3</div>
                  <div className="step-title">
                    <h3>Achieve JCP Certification</h3>
                  </div>
                </div>
                <div className="step-content">
                  <p>
                    Achieve Joint Certification Program/advanced certification <a href="https://www.dla.mil/Logistics-Operations/Services/JCP/" target="_blank" rel="noopener noreferrer">JCP Home</a> - A JCP (Joint Certification Program) certification allows U.S. and Canadian companies to access unclassified U.S. Department of Defense (DOD) or Canadian Department of National Defence (DND) technical data, often necessary for defense-related work.
                  </p>
                  <p>To obtain JCP certification, a company must:</p>
                  <ul>
                    <li>Be located in the U.S. or Canada</li>
                    <li>Have an active SAM registration</li>
                    <li>Possess a CAGE code</li>
                    <li>Undergo a cybersecurity assessment to document a NIST 800-171 self-assessment in the Supplier Performance Risk System (SPRS)</li>
                    <li>Complete and submit <a href="https://www.esd.whs.mil/Portals/54/Documents/DD/forms/dd/dd2345.pdf" target="_blank" rel="noopener noreferrer">DD Form 2345</a>.</li>
                  </ul>
                  <p>
                    JCP registration allows US and Canadian entities to access unclassified military technical data and provides manufactures the opportunity to access those technical data packages.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default GettingStarted; 


// WEBPACK FOOTER //
// ./src/pages/static/GettingStarted/GettingStarted.jsx